export default "__VITE_ASSET___1r2JWaj7oGUrnkkeqfDxQ__";